import { z } from 'zod';

/**
 * Custom Zod schema for Prisma Decimal values
 * Handles both Prisma.Decimal objects and regular numbers
 */
export const decimalSchema = z.preprocess(
  // Handle conversion in preprocessing step
  (val) => {
    if (val === null || val === undefined) return null;
    if (typeof val === 'number') return val;
    // Handle Decimal.js object from Prisma
    if (typeof val === 'object' && val !== null && 'toNumber' in val) {
      return typeof val.toNumber === 'function' 
        ? val.toNumber() 
        : Number(val.toString());
    }
    return Number(val.toString());
  },
  // Then validate as number or null
  z.number().or(z.null())
);

/**
 * Optional decimal schema that allows null/undefined values
 */
export const optionalDecimalSchema = decimalSchema.optional();

/**
 * Create a decimal schema with min/max validation
 */
export function createDecimalSchema(options?: { min?: number; max?: number }) {
  let schema = z.number();
  
  if (options?.min !== undefined) {
    schema = schema.min(options.min);
  }
  
  if (options?.max !== undefined) {
    schema = schema.max(options.max);
  }
  
  return z.preprocess(
    (val) => {
      if (val === null || val === undefined) return null;
      if (typeof val === 'number') return val;
      if (typeof val === 'object' && val !== null && 'toNumber' in val) {
        return typeof val.toNumber === 'function' 
          ? val.toNumber() 
          : Number(val.toString());
      }
      return Number(val.toString());
    },
    schema.or(z.null())
  );
} 